import { EssentialsContentData } from '../../essentials/types'

/** Post messages defined through the CMS. Add shared events here. Events sent directly from goodness should go in `CMS_MICROSITE_IFRAME_MESSAGES` */
export const CMS_MICROSITE_MESSAGE_KEY = {
  CLICK_SELF_CARE_CONTENT: 'clickSelfCareContent',
  NAVIGATE_TO_FORKED_TRIAGE: 'navigateToForkedTriage',
  NAVIGATE_TO_CRITICAL_INCIDENT_SUPPORT_TOOLKIT: 'navigateToCriticalIncidentSupportToolkit',
  NAVIGATE_TO_WELLNESS_CHECK_IN: 'navigateToWellnessCheckIn',
  NAVIGATE_TO_ESSENTIALS: 'navigateToEssentials',
  REGISTER_WEBINAR: 'registerWebinar',
  NAVIGATE_TO_WEBINAR_EVENTS: 'navigateToWebinarEvents',
  NAVIGATE_TO_REGISTRATION: 'navigateToRegistration',
  OPEN_EXTERNAL_LINK: 'openExternalLink',
  NAVIGATE_TO_PROVIDER_BOOKING: 'navigateToProviderBooking',
  NAVIGATE_TO_DIRECT_PATH_BOOKING: 'navigateToDirectPathBooking',
  OPEN_CONTACT_CARE_NAVIGATOR_MODAL: 'openContactCareNavigatorModal',
  CONTACT_CARE_NAVIGATOR_BY_PHONE: 'contactCareNavigatorByPhone',
  SCHEDULE_RESOURCE_COORDINATOR_CALL: 'scheduleResourceCoordinatorCall',
  OPEN_CARE_NAVIGATOR_INFO: 'open care navigator info',
} as const
export type CMS_MICROSITE_MESSAGE = (typeof CMS_MICROSITE_MESSAGE_KEY)[keyof typeof CMS_MICROSITE_MESSAGE_KEY]

export const RESOURCE_COORDINATOR_MICROSITE_MESSAGE_KEY = {
  ...CMS_MICROSITE_MESSAGE_KEY,
  DOCUMENT_OBJECT: 'Document Object',
  CLICK_SCHEDULE_RESOURCE_COORDINATOR_CALL: 'scheduleResourceCoordinatorCall',
  OPEN_CARE_NAVIGATOR_INFO: 'open care navigator info',
} as const

export const COMPLEX_CARE_CMS_MICROSITE_MESSAGE_KEY = {
  ...CMS_MICROSITE_MESSAGE_KEY,
  NAVIGATE_TO_MEDS_BOOKING: 'navigateToMedsBooking',
  NAVIGATE_TO_RENEW_BOOKING: 'navigateToRenewBooking',
  SCHEDULE_COMPLEX_CARE_CALL: 'scheduleComplexCareCall',
  SCHEDULE_DBT_ASSESSMENT_CALL: 'scheduleDBTAssessmentCall',
  NAVIGATE_TO_SUBPAGE: 'navigateToSubpage',
  OPEN_LEARN_MORE_PANEL: 'openLearnMorePanel',
  CLOSE_LEARN_MORE_PANEL: 'closeLearnMorePanel',
  EXPAND_FAQ: 'expandFAQ',
} as const
export type COMPLEX_CARE_CMS_MICROSITE_MESSAGE =
  (typeof COMPLEX_CARE_CMS_MICROSITE_MESSAGE_KEY)[keyof typeof COMPLEX_CARE_CMS_MICROSITE_MESSAGE_KEY]

export type CMSMessageData = {
  mixPanelData: {
    entrypoint?: string
    question?: string
    event?: string
    page?: string
    ctpo?: string
  }
  contentData?: EssentialsContentData
}
